// @flow
import type { Promocode } from "booking/services/promocode/reducer"
import * as abandonment from "../services/utils/abandonment"

const changeLanguage = (language: string, promocode?: Promocode) => {
  const loc = window.location
  const parts = loc.pathname.split("/")
  const restOfUrl = parts.slice(2).join("/")
  abandonment.cancel()
  if (promocode && promocode.code) {
    window.location.href = `${window.location.origin}/${language}/${restOfUrl}${loc.search}&promocode=${promocode.code}`
  } else {
    window.location.href = `${window.location.origin}/${language}/${restOfUrl}${loc.search}`
  }
}

export default changeLanguage
